import { createStateHook, type HookStateFunction } from 'react-sweet-state';

import { type Actions, store } from '../../main';
import type { AppId, IssueAdjustmentsState } from '../../types';
import type { AppError } from '../../utils/errors/types';

export type UseAppErrors = {
	appErrors: AppError[] | null;
};

export const useAppErrors: HookStateFunction<
	UseAppErrors,
	{
		appId: AppId;
	}
> = createStateHook<IssueAdjustmentsState, Actions, UseAppErrors, { appId: AppId }>(store, {
	selector: (state, { appId }) => ({ appErrors: state.appsErrors[appId] ?? null }),
});
